/**
 * @file Defines constants for GRN (Goods Received Note) types.
 */

export const GRN_TYPE = {
  PURCHASE_ORDER: 'purchase_order',
  GATE_PASS: 'gate_pass',
};

/**
 * Returns a human-readable label for a given GRN type.
 * @param {string} type - The GRN type (e.g., 'purchase_order', 'gate_pass').
 * @returns {string} The human-readable label.
 */
export const getGrnTypeLabel = type => {
  switch (type) {
    case GRN_TYPE.PURCHASE_ORDER:
      return 'Purchase Order';
    case GRN_TYPE.GATE_PASS:
      return 'Gate Pass';
    default:
      return type; // Fallback to the original type if not recognized
  }
};
